import { UserProfileEdit } from '../user/settings/UserProfileEdit';
import { Card } from '@startuptools/ui/Card';
import { Typography } from '@startuptools/ui/Typography';
import { Trans } from '@lingui/react';
import { useNavigate } from 'react-router-dom';

export const OnboardingUserProfileEdit = () => {
  const navigate = useNavigate();

  return (
    <Card sx={{ minWidth: { xs: '95vw', md: 738 }, maxWidth: 900 }}>
      <UserProfileEdit
        title={
          <Typography level="h2">
            <Trans id="Finish your user profile to get started" />
          </Typography>
        }
        onClose={() => navigate('../create-company', { replace: true })}
        showReferralFields
      />
    </Card>
  );
};
